import { render, staticRenderFns } from "./Servertime.vue?vue&type=template&id=c38b0c3e&"
import script from "./Servertime.vue?vue&type=script&lang=js&"
export * from "./Servertime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports